// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import router from './router'
// 引入echarts
import echarts from 'echarts'
import ElementUI from 'element-ui'
// import '../theme/index.css'
// 引入默认的element-ui样式
import 'element-ui/lib/theme-chalk/index.css'

// element-ui全局样式，修改：reset.css variables.scss index.css
import './assets/css/reset.css'
import './assets/css/common.scss' 
import "./assets/fonts/iconfont.css";

// 全局修改element-ui主题样式
import './assets/css/variables.scss'

// 引入iview
import iView from 'iview';
import 'iview/dist/styles/iview.css';

// 中英文切换功能
import i18n from './components/i18n' 
// 手机号码校验
import validatePhone from  './components/regValidate/validate'

import App from './App'


// axios
import { fetchGet, fetchPost, fetchPostUpload } from './api/axiosConfig'
Vue.config.productionTip = false

import uweb from 'vue-uweb'
if (location.hostname==='api.kidsrkidschina.com') {
  Vue.use(uweb, '1275738794')
} else {
  Vue.use(uweb, '1275738785')
}

// 封装全局：$get() $post()方法，调用：this.$get()
Vue.prototype.$get = fetchGet
Vue.prototype.$post = fetchPost
Vue.prototype.$postUpload = fetchPostUpload
// 监听的sessionStorage变化
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'user_empNo') {
      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);
              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}


// 设置全局引用的echarts
Vue.prototype.$echarts = echarts 

Vue.use(ElementUI)
Vue.use(validatePhone)
Vue.use(iView);
//引入地市联动
import AmazeVue from 'amaze-vue';
import 'amaze-vue/dist/amaze-vue.css';
Vue.use(AmazeVue);
// 导航守卫
router.beforeEach((to, from, next) => {
  // 进入页面之前还有上一个页面的请求，强制取消
  if(Vue.prototype.sources.length > 0) {
    Vue.prototype.sources.pop()
  }
  if(to.name=="login" || sessionStorage.getItem('token')){
    next()
  }else  if(!sessionStorage.getItem('token')){
    next('/login');
  }
});
/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js